import styled from "styled-components";

export const StyledLoadingdiv = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: rgba(55, 55, 55, 0.5);
  position: fixed;
  top: 0;
  right: 0;
  z-index: 2000;
  * {
    width: auto;
    height: 30px;
    display: flex;
    color: white;
    justify-content: center;
  }
`;
export const StyledProgressdiv = styled.progress`
transform: scaleX(-1);
`;

// .isModal {
//   width: 100%;
//   background-color: transparent;
// }